import { EnumReportTypes, ILoanColumn } from '../types/reports';
import { formatAmount } from './formatAmount';

export const calculatePrincipalInterest = (loan: ILoanColumn, inputInterestRate?: number) => {
  const { loanAmount, interestRate, loanPeriodInYears, addUip, loanAmountWithUip, interestOnly, externalLoan } = loan;
  // @ts-ignore loan?.reportType as EnumReportTypes
  const isRefinance = loan?.reportType === EnumReportTypes.refinance;

  const addVaFundingFee = externalLoan?.addVaFundingFee;
  const addClosingCosts = externalLoan?.addClosingCosts;
  const addCashOut = externalLoan?.addCashOut;

  const rateValue = inputInterestRate ?? parseFloat(interestRate?.value as string);

  if (!loanAmount?.value || !rateValue) return '0';

  const R = (addUip || addVaFundingFee || (addClosingCosts && isRefinance) || addCashOut) && loanAmountWithUip ?
    parseFloat(loanAmountWithUip?.value as string) : parseFloat(loanAmount.value as string);

  const r = rateValue / 100 / 12;
  const n = (parseFloat(loanPeriodInYears?.value as string) || 30) * 12;

  const x = (1 + r) ** n;
  const M = formatAmount(R * ((r * x) / (x - 1)));

  if (interestOnly) {
    let value;

    const rate = rateValue;

    if (R != null && rate != null) {
      value = (R * rate) / 100 / 12;

      return formatAmount(value);
    }

    return '0';
  }

  return Number.isNaN(M) ? '0' : M;
}
